<template lang="html">
  <div class="model" v-if="modal">
    <div class="model-body">
      <div class="model-header">
        提示
      </div>
      <div class="model-content">
        <div>{{label1}}</div>
      </div>
      <div class="model-footer" @click="closeModal">
        <button type="button" name="button" >确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tip',
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      modal: true,
      label1: this.label
    }
  },
  methods: {
    closeModal () {
      this.modal = false
      this.$emit('closeModel')
    }
  }
}
</script>

<style lang="scss" scoped>
.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  .model-body {
    margin: calc(50vh - 72px) auto;
    width: 36%;
    min-width: 250px;
    box-sizing: border-box;
    background-color: #dad7da;
    border-radius: 14px;
    .model-header {
      font-size: 17px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(0,0,0,1);
      line-height: 22px;
      text-align: center;
      padding-top: 19px;
    }
    .model-content {
      width: 100%;
      padding: 11px 0 18px 0;
      div{
        text-align: center;
        font-size: 13px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height: 16px;
        &:first-child {
          margin-top: 6px;
        }
      }
    }
    .model-footer {
      border-top: 1px solid rgba(60, 60, 67, 0.29);
      height: 43px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;
      position: relative;
      button {
        height: 43px;
        line-height: 43px;
        color: rgba(0, 122, 255, 1);
        text-align: center;
        box-sizing: border-box;
        border: none;
        background: transparent;
        font-size: 17px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(21,181,141,1);
      }
    }
  }
}
</style>
